import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/base.css";
import "./styles/home.css";
import "./styles/bulandiThemeRoot.css";
import "./styles/bulandiThemeButtons.css";
import "./styles/bulandiThemeSecondaryButtons.css";
import "./styles/bulandiThemeEffects.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
